// FaroErrorBoundary — catches React render errors, reports them to Faro RUM,
// shows a minimal fallback. No-op-safe when RUM is off.
import React from "react";
import { reportError } from "./faro";

export default class FaroErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportError(error, { componentStack: info && info.componentStack });
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return React.createElement(
        "div",
        { style: { padding: 24, fontFamily: "sans-serif" } },
        React.createElement("h2", null, "Something went wrong."),
        React.createElement("button", { onClick: () => window.location.reload() }, "Reload")
      );
    }
    return this.props.children;
  }
}
